"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("shared/components/Button"));
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var PREFIX = 'TenantChoiceModal';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    buttonWrapper: "".concat(PREFIX, "-buttonWrapper"),
};
var StyledModal = (0, styles_1.styled)(Modal_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            '& .selectRemove': {
                display: 'none',
            },
        },
        _b[".".concat(classes.buttonWrapper)] = {
            '& .MuiButton-root': {
                marginRight: theme.spacing(2),
            },
        },
        _b);
});
var TenantChoiceModal = function (_a) {
    var isOpen = _a.isOpen, setTenant = _a.setTenant, tenants = _a.tenants;
    var _b = __read(react_1.default.useState(true), 2), open = _b[0], setOpen = _b[1];
    var handleClose = function () {
        setOpen(!isOpen);
    };
    return ((0, jsx_runtime_1.jsxs)(StyledModal, __assign({ open: open && isOpen, onClose: handleClose, label: "Tenant Choice Modal", maxWidth: "md", className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h1" }, { children: "Multiple organizations found" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ py: 3, component: "p" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "body1" }, { children: ["Your have connected ", tenants === null || tenants === void 0 ? void 0 : tenants.length, " organizations to "] })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ className: classes.buttonWrapper }, { children: isOpen && setTenant && (tenants === null || tenants === void 0 ? void 0 : tenants.map(function (_a) {
                    var tenantId = _a.tenantId, tenantName = _a.tenantName;
                    return ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return setTenant({ tenantId: tenantId, tenantName: tenantName }); } }, { children: tenantName }), tenantId));
                })) }))] })));
};
exports.default = TenantChoiceModal;
